import React from 'react'
import ContainerLayout from '../../../../components/container-layout/ContainerLayout'
import NavigateListCustom from '../../../../components/navigation/NavigationListCustom'
import { routeName } from '../../../../routes/routeName'
import StateComponents from '../../../../components/state-component/StateComponents'
import TableCustom from '../../../../components/table/tableCustom'
import { debouncedApiCall } from '../../../../utils/app.utils'
import ManageState from './manageState'
import ModalCustom from '../../../../components/modal/ModalCustom'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'

type Props = {}

const ActivityCategories: React.FC<Props> = ({ }: Props) => {
    const { t } = useTranslation();
    const location = useLocation();
    const pathname = location.pathname
    const {
        page,
        pageLimit,
        setPage,
        setPageLimit,
        sortBy,
        sortType,
        handleRequestSort,
        headCells,
        renderData,
        data,
        totalItems,
        // handleDownloadReport,
        showModal,
        handleCloseModal,
        form,
        set_form,
        handleSubmitForm,
        setShowModal,
        setKeyword,
        handleChangeDateRange,
        date_range,
        handleClearDateRange,
        checkPermit
    } = ManageState()
    return (
        <div className='w-full'>
            <ContainerLayout
                title={t("หมวดหมู่กิจกรรม")}
                hidden_sub_title
                navigateContent={
                    <NavigateListCustom
                        navigateData={[
                            {
                                key: "complaintSubmit",
                                name: t("ตั้งค่า"),
                                disabled_match: true,
                                pathName: ""
                            },
                            {
                                key: "complaintSubmit",
                                name: t("หมวดหมู่กิจกรรม"),
                                pathName: pathname
                            },
                        ]}
                    />
                }
                buttonContent={
                    // <ContainerButton
                    //     justifyContent='flex-end'
                    //     buttonData={[
                    //         {
                    //             buttonProps: {
                    //                 onClick: handleDownloadReport
                    //             },
                    //             key: "DOWNLOAD_CSV",
                    //             label: t("COMPLAINTS_DOWNLOAD_CSV"),
                    //             seq: 1,
                    //             type: "DOWNLOAD_CSV"
                    //         }
                    //     ]}
                    // />
                    <></>
                }
                content={
                    <div className='w-full'>

                        <StateComponents
                            otherProps={{ spacing: 2 }}
                            typeProps={[
                                {
                                    seq: 1,
                                    type: "TEXT_FIELD",
                                    gridProps: {
                                        xs: 12,
                                        md: 4
                                    },
                                    fieldProps: {
                                        placeholder: "ค้นหา ชื่อ",
                                        onChange: (e) => debouncedApiCall({ setItem: setKeyword, searchItem: e.target.value })
                                    }
                                },
                                {
                                    seq: 2,
                                    type: "DATE_RANGE",
                                    gridProps: {
                                        xs: 12,
                                        md: 3
                                    },
                                    fieldProps: {
                                        onchange: handleChangeDateRange,
                                        value: date_range || [],
                                        onClear: handleClearDateRange,
                                        allowClear: true,
                                        placeholder: "ช่วงวันที่"
                                    }
                                },
                                {
                                    type: "COMPONENT",
                                    seq: 3,
                                    fieldProps: {
                                        element: <></>
                                    },
                                    gridProps: {
                                        xs: 12,
                                        md: 3
                                    }
                                },
                                {
                                    seq: 4,
                                    type: "BUTTON",
                                    gridProps: {
                                        xs: 6,
                                        md: 2
                                    },
                                    hidden: !checkPermit.isCreated,
                                    fieldProps: {
                                        justifyContent: "flex-end",
                                        buttonData: [
                                            {
                                                seq: 1,
                                                key: "ADD2",
                                                label: "เพิ่มหมวดหมู่กิจกรรม",
                                                buttonProps: {
                                                    onClick: () => {
                                                        setShowModal("ADD")
                                                    },
                                                },
                                                type: "ADD2"
                                            }
                                        ]
                                    }
                                }
                            ]}
                        />

                        <section className='w-full mt-4'>
                            <TableCustom
                                tableMinWidth={1000}
                                tableFixedWidth
                                customScroll
                                page={page}
                                pageLimit={pageLimit}
                                sortBy={sortBy}
                                sortType={sortType}
                                headCells={headCells}
                                rowCount={totalItems}
                                rowsData={data?.map((data: any, i: any) => {
                                    return renderData(data, i)
                                })}
                                onSort={handleRequestSort}
                                setPageLimit={(value: number) => setPageLimit(value)}
                                setPage={(value: number) => setPage(value)}
                            />
                        </section>
                    </div>
                }
            />

            {showModal !== '' && (
                <ModalCustom
                    open
                    title={showModal === 'ADD' ? t("เพิ่มหมวดหมู่กิจกรรม") : t("ข้อมูลหมู่กิจกรรม")}
                    subTitle={t("กรุณาระบุข้อมูลให้ครบถ้วนก่อนการยืนยัน")}
                    onClose={handleCloseModal}
                    containerButton={{
                        disabled_submit: !form.activity_category_name,
                        hidden_submit: showModal === 'VIEW',
                        onClose: handleCloseModal,
                        onSubmit: () => handleSubmitForm()
                    }}
                    component={
                        <div className='w-full'>
                            <StateComponents
                                disabledAllField={showModal === 'VIEW'}
                                typeProps={[
                                    {
                                        seq: 1,
                                        type: "TEXT_FIELD",
                                        gridProps: {
                                            xs: 12
                                        },
                                        fieldProps: {
                                            heading: t("ชื่อหมวดหมู่กิจกรรม"),
                                            required: true,
                                            value: form.activity_category_name,
                                            onChange: (e) => set_form((prev) => ({ ...prev, activity_category_name: e.target.value }))
                                        }
                                    }
                                ]}
                            />
                        </div>
                    }
                />
            )}
        </div>
    )
}

export default ActivityCategories